import axios from 'axios';
import {removeToken} from '@/common'
import vm from '@/main'

// 创建axios实例
const axiosInstance = axios.create()

/**
 * 请求拦截器
 */
axiosInstance.interceptors.request.use(config => {
  return config
}, err => { // 当请求异常时返回错误
  return Promise.reject(err); // 假设请求时不会出错
});

/**
 * 响应拦截器
 */
axiosInstance.interceptors.response.use(res => {
  return res
}, err => {
  // token失效或者未登录
  if (err.response && err.response.status === 401) {
    removeToken()
    vm.$store.commit('auth/updateLoginStatus', false)
    vm.$store.commit('auth/updateToken', '')
  }
  return Promise.reject(err)
});

export default axiosInstance



// WEBPACK FOOTER //
// ./src/api/http_client.js